import { CommonModule, DatePipe } from '@angular/common';
import { AfterViewInit, Component, DestroyRef, ElementRef, OnDestroy, OnInit, Optional, ViewChild, inject } from '@angular/core';
import { OrderCreation, OrderService, OrderUpdate, DefaultService } from 'com.trumbull.phx.order.api-client';
import { CaseFileItemCreation, CaseFileItemService, CaseFilePartyItemCreation, PartyLocatorCreation } from 'com.trumbull.phx.casefile.api-client';
import * as _ from 'lodash';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { StepperModule } from 'primeng/stepper';
import { ToastModule } from 'primeng/toast';
import { OrderInfoComponent } from '../../order-info/order-info.component';
import { AuthorizationComponent } from '../authorization/authorization.component';
import { RecordsComponent } from '../records/records.component';
import { SubjectsComponent } from '../subjects/subjects.component';
import { SubpoenaComponent } from '../subpoena/subpoena.component';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { Step, steps, PartyTypeCode, PartyRoleCode, RequestRef, states, Order, PartyEntry, PartyRelationships } from './place-order.model';
import { CheckboxModule } from 'primeng/checkbox';
import { AbstractControl, FormArray, FormsModule } from '@angular/forms';
import { OrderInfo } from '../../order-info/order-info.model';
import { RecordRetrievalItemService, RecordRetrievalPartyItemCreation, RecordRetrievalPartyRoleItemCreation, RecordRetrievalRequestRecordScopeItemCreation } from 'com.trumbull.phx.recordretrievalobjective.api-client';
import { buildDocumentLists, DocumentListValidationError, RecordRetrievalObjectiveItemCreation, RecordRetrievalRequestItemCreation } from '../document-lists';
import { Authorizations } from '../authorization/authorization.model';
import { Subpoena } from '../subpoena/subpoena.model';
import { Subjects } from '../subjects/subjects.model';
import { Records } from '../records/records.model';
import { IPSAuthenticationService, IPSObservabilityService, IPSTenantKeyService } from '@ips/common-angular';
import { environment } from '@env/environment';
import { OrderMapperService } from '../../services/order-mapper/order-mapper.service';
import { Observable, catchError, combineLatest, filter, finalize, map, of, switchMap, tap } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LoaderService } from '../../services/loader-service/loader.service';
import { SharedService } from '../../services/shared.service';
import { VocabHelperService } from '../../services/vocab-helper/vocab-helper.service';
import { WorkService } from 'com.trumbull.phx.work.api-client';
import { DocumentProcessingService } from '../../services/document-processor/document-processor.service';
import { CleanStepPanelAccessibilityDirective } from '../../order-info/accesibility.directive';
import { AttachmentProcessorService } from './attachment.processor.service';
import { CreateUuidService } from '../../services/create-uuid/create-uuid.service';
import { ContactItemCreation } from 'com.trumbull.phx.contactlist.api-client';
import { DateUtilService } from '../../services/date-util/date-util.service';
import { PlaceOrderPartyFactoryService } from './place-order-party-factory.service';
import { ContactHelperService } from '../../services/contact-helper/contact-helper.service';
import { OrderHydrationService } from '../../services/order-hydration/order-hydration.service';
import { API_CONTEXT, ORDER_CATEGORY, SERVICE_LEVEL } from 'src/assets/base/constant';
import { RequestNumberValidatorService } from 'src/app/services/validate-request-number/request-number-validator.service';
@Component({
  selector: 'app-place-order',
  imports: [
    StepperModule,
    ButtonModule,
    CommonModule,
    OrderInfoComponent,
    SubjectsComponent,
    AuthorizationComponent,
    SubpoenaComponent,
    RecordsComponent,
    ToastModule,
    CheckboxModule,
    FormsModule,
    CleanStepPanelAccessibilityDirective,
  ],
  templateUrl: './place-order.component.html',
  styleUrl: './place-order.component.scss',
  providers: [MessageService, DatePipe],
})
export class PlaceOrderComponent implements OnInit, AfterViewInit, OnDestroy{
  private readonly destroyRef = inject(DestroyRef);
  @ViewChild('placeOrderHeading') placeOrderHeading!: ElementRef;

  constructor(
    private messageService: MessageService,
    private readonly orderService: OrderService,
    private readonly defaultOrderService: DefaultService,
    private readonly router: Router,
    private readonly authService: IPSAuthenticationService,
    private readonly orderMapperService: OrderMapperService,
    private readonly vocabHelperService: VocabHelperService,
    private route: ActivatedRoute,
    private readonly loaderService: LoaderService,
    private readonly sharedService: SharedService,
    private readonly workService: WorkService,
    private readonly recordRetrievalObjectiveService: RecordRetrievalItemService,
    private readonly caseFileItemService: CaseFileItemService,
    private readonly documentProcessor: DocumentProcessingService,
    private readonly tenantKeyService: IPSTenantKeyService,
    private attachmentsProcessorService: AttachmentProcessorService,
    private CreateUUIDService: CreateUuidService,
    private dateUtilService: DateUtilService,
    @Optional() private readonly observability: IPSObservabilityService,
    private readonly contactHelperService: ContactHelperService,
    private readonly partyFactoryService: PlaceOrderPartyFactoryService,
    private readonly orderHydrationService: OrderHydrationService,
    private readonly validatorService: RequestNumberValidatorService
  ) {
    this.orderId$ = this.route.paramMap.pipe(
      switchMap((params: ParamMap) => {
        return new Observable<string | null>((observer) => {
          observer.next(params.get('id'));
          observer.complete();
        });
      }),
    );
  }

  @ViewChild(OrderInfoComponent) orderInfoComponent!: OrderInfoComponent;
  @ViewChild(SubjectsComponent) subjectsComponent!: SubjectsComponent;
  @ViewChild(SubpoenaComponent) subpoenaComponent!: SubpoenaComponent;
  @ViewChild(AuthorizationComponent)
  authorizationComponent!: AuthorizationComponent;
  @ViewChild(RecordsComponent) recordsComponent!: RecordsComponent;
  orderId$: Observable<string | null>;
  orderInfoData: OrderInfo | undefined;
  subjectsData: Subjects | undefined;
  subpoenaData: Subpoena | undefined;
  authorizationData: Authorizations | undefined;
  recordsData: Records | undefined;
  activeStep: number = 1;
  activeSteps: Step[] = _.cloneDeep(_.filter(steps, 'visible'));
  isFormValid: boolean = false;
  isFormSubmitted: boolean = false;
  invalidControls: string[] = [];
  states = environment.noAuth ? states : [];
  isEditOrder: boolean = false;
  orderNumber: any;
  mappedOrderDetails: Order | undefined;
  invalidFormFields: string[] = [];
  caseFileData: any;
  recordRetrievalObjectiveData: any;
  orderStartDateTime = new Date();
  loggedinUserAccount: string = '';
  // accountsWithoutSubpoena: string[] = ['bm', 'ohm'];
  selectedTenant?: string | null;
  vocabDocumentTagsData: any = [];
  partyRelationships: PartyRelationships[] = [];
  newContactsForContactBook: any[] = [];
  subpoenaStepperRequired: boolean = true;
  private placeOrderCompleted = false;
  private readonly stateVocabularyName = 'PhysicalLocationUsAddressStateCode';
  private readonly documentTypeVocabularyName = 'DocumentTypeCode';
  private readonly createModeVocabularyNames = [this.stateVocabularyName];
  private readonly editModeVocabularyNames = [
    'OrderType',
    'ContactTitle',
    this.stateVocabularyName,
    'RecordTypes',
    'VA_Options',
    'UserOrganization',
    'ImagingTypes',
    'OrderDocumentCode',
  ];

    private trackPlaceOrder(name: string, extra: Record<string, unknown> = {}): void {
    const currentStep = _.find(this.activeSteps, ['value', this.activeStep]);
    const attributes: Record<string, string> = {
      step: currentStep?.label ?? 'unknown',
      stepValue: String(this.activeStep),
      isEditOrder: String(this.isEditOrder),
      selectedTenant: this.selectedTenant ?? '',
      orderCategory: this.orderInfoData?.selectedCategory ?? '',
      subpoenaStepperRequired: String(this.subpoenaStepperRequired),
      elapsedMs: String(Date.now() - this.orderStartDateTime.getTime())
    };

    Object.entries(extra).forEach(([key, value]) => {
      attributes[key] = value == null ? '' : String(value);
    });

    this.observability?.trackEvent(name, attributes);
  }

  ngOnInit(): void {
    this.setBreadcrumbPath();

    this.subscribeToCurrentUserAndTenant();

    if (this.router.url.startsWith('/home/edit-order')) {
      this.initializeEditOrderMode();
    } else {
      this.initializeCreateOrderMode();
    }

    this.attachmentsProcessorService.setRequestDocuments([]);
    this.trackPlaceOrder('place-order:started');
  }

  ngOnDestroy(): void {
    if (!this.placeOrderCompleted) {
      this.trackPlaceOrder('place-order:abandoned');
    }
  }

  private subscribeToCurrentUserAndTenant(): void {
    this.authService.currentUser
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((user) => {
        this.tenantKeyService
          .getTenantKey()
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe((selectedTenant) => {
            this.selectedTenant = selectedTenant;
            const organizationValue: any = user?.definition?.attributes?.find(
              (item) =>
                item?.key === 'organization' &&
                item?.tenantKey?.toLowerCase() ===
                  this.selectedTenant?.toLowerCase(),
            );

            this.loggedinUserAccount = organizationValue?.value ?? '';

            if (this.loggedinUserAccount !== '') {
              this.defaultOrderService
                .searchAccount(
                  API_CONTEXT.STANDARD,
                  this.loggedinUserAccount,
                  'SubpoenaRequiredForExtUser',
                  'true',
                )
                .pipe(takeUntilDestroyed(this.destroyRef))
                .subscribe((data) => {
                  if (data && data.length > 0) {
                    let configurations = data[0].configurations;
                    if (configurations && configurations.length > 0) {
                      this.subpoenaStepperRequired =
                        configurations[0].configurationValue?.toLowerCase() ===
                        'false'
                          ? false
                          : true;
                    }
                  }
                });
            }
          });
      });
  }

  private initializeEditOrderMode(): void {
    this.isEditOrder = true;
    this.loaderService.show();

    this.orderId$
      .pipe(
        filter((id) => !!id),
        switchMap((id: string | null) => this.loadEditOrderData(id)),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }

  private initializeCreateOrderMode(): void {
    this.vocabHelperService
      .getVocabData(this.createModeVocabularyNames)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data) => {
        this.applyStateVocabulary(data);
      });

    this.attachmentsProcessorService.setRequests([]);
    this.attachmentsProcessorService.setAllDocuments([]);
  }

  private loadEditOrderData(id: string | null): Observable<any> {
    if (!id) {
      return of(null);
    }

    this.orderNumber = id;

    const hydration$ =
      this.orderHydrationService.hydrateOrderWithCaseAndRetrieval(id);

    const vocabData$ = this.vocabHelperService
      .getVocabData(this.editModeVocabularyNames)
      .pipe(
        tap((data) => {
          if (data) {
            this.applyStateVocabulary(data);
            this.vocabDocumentTagsData = data?.find(
              (d: any) => d.vocabularyName === this.documentTypeVocabularyName,
            );
          }
        }),
        catchError((error) => {
          console.error('Error fetching order:', error);
          this.trackPlaceOrder('place-order:edit:load-failed', { source: 'vocab' });
          return of(null);
        }),
      );

    return combineLatest([hydration$, vocabData$]).pipe(
      switchMap(([hydration, vocabData]) =>
        this.mapEditOrderResponse(
          hydration?.order,
          vocabData,
          hydration?.caseData,
          hydration?.recordRetrievalData,
        ),
      ),
      catchError(() => {
        return of(null);
      }),
      finalize(() => this.loaderService.hide()),
    );
  }

  private applyStateVocabulary(data: any): void {
    const vocabData = data?.find(
      (d: any) => d.vocabularyName === this.stateVocabularyName,
    );
    if (vocabData) {
      this.states = vocabData.vocabularyItems.map((item: any) => ({
        name: item.description,
        value: item.code,
      }));
    }
  }

  private loadCaseAndRetrievalForEdit(
    order: any,
    vocabData: any,
    work: any,
  ): Observable<any> {
    if (!work?.workItems?.length || !order) {
      return of(null);
    }

    const objectiveId = work.workItems?.[0]?.stories?.[0]?.objectiveId || '';

    const caseFile$ = this.caseFileItemService
      .getCaseFile(work.workItems?.[0].subjectId || '', API_CONTEXT.STANDARD)
      .pipe(
        catchError((error) => {
          console.error('Error fetching case items:', error);
          this.trackPlaceOrder('place-order:edit:load-failed', { source: 'case-file' });
          return of(null);
        }),
      );

    const recordRetrieval$ = this.recordRetrievalObjectiveService
      .getRecordRetrievalObjective(objectiveId || '', API_CONTEXT.STANDARD)
      .pipe(
        catchError((error) => {
          console.error('Error fetching recordRetrieval items:', error);
          this.trackPlaceOrder('place-order:edit:load-failed', { source: 'record-retrieval' });
          return of(null);
        }),
      );

    return combineLatest([caseFile$, recordRetrieval$]).pipe(
      switchMap(([caseData, recordRetrievalData]) =>
        this.mapEditOrderResponse(
          order,
          vocabData,
          caseData,
          recordRetrievalData,
        ),
      ),
    );
  }

  private mapEditOrderResponse(
    order: any,
    vocabData: any,
    caseData: any,
    recordRetrievalData: any,
  ): Observable<any> {
    if (!caseData || !recordRetrievalData) {
      return of(null);
    }

    this.caseFileData = caseData;
    this.recordRetrievalObjectiveData = recordRetrievalData;
    this.attachmentsProcessorService.setRequests(
      this.recordRetrievalObjectiveData.requests,
    );
    const documentIds =
      recordRetrievalData.documentLists
        ?.flatMap((item: any) => item.documentListId)
        .filter((docId: any): docId is string => docId !== undefined) || [];

    return this.documentProcessor
      .fetchDocuments2(documentIds, () => {
        // do nothing here
      })
      .pipe(
        map((documents: any) => {
          this.mappedOrderDetails =
            this.orderMapperService.mapOrderJsonToFormObject(
              order,
              {
                case: caseData,
                retrievalObjective: recordRetrievalData,
                attachments: documents,
              },
              vocabData,
            );
          this.loaderService.hide();

          if (this.mappedOrderDetails) {
            this.orderInfoData = this.mappedOrderDetails.orderInfo;
            this.authorizationData = this.mappedOrderDetails.authorization;
            this.recordsData = this.mappedOrderDetails.records;
            this.subjectsData = this.mappedOrderDetails.subjects;
            this.subpoenaData = this.mappedOrderDetails.subpoena;
            this.updateStepper(this.orderInfoData?.selectedCategory);
          }

          return of(null);
        }),
      );
  }

  /**
   * Called after the view has been initialized. add focus to the top header
   */
  ngAfterViewInit() {
    setTimeout(() => {
      this.placeOrderHeading.nativeElement.focus();
    });
  }

  // Validates attorney requirement based on selected order category.
  CheckIfAttornySelected(): boolean {
    const selectedCategory = this.orderInfoData?.selectedCategory;
    if (
      (selectedCategory === ORDER_CATEGORY.SUBPOENA_TO_BE_PREPARED ||
        selectedCategory === ORDER_CATEGORY.AUTHORIZATION_NOT_PROVIDED) &&
      this.orderInfoData &&
      this.orderInfoData?.contacts?.filter(
        (contact: any) => contact.contactTitle?.value === 'attorney',
      )?.length <= 0
    ) {
      this.messageService.add({
        severity: 'error',
        summary: ORDER_CATEGORY.TOAST_SUMMARY_ERROR,
        detail: 'Please add one contact as attorney to place this order',
        sticky: true,
      });
      this.trackPlaceOrder('place-order:validation:failed', { reason: 'attorney' });
      return false;
    }
    return true;
  }

  onPrevious() {
    this.messageService.clear();
    let stepIndex = _.findIndex(
      this.activeSteps,
      (item: { value: number }) => item.value == this.activeStep,
    );
    const fromStep = this.activeSteps[stepIndex];
    this.updateFormData(this.activeSteps[stepIndex]);
    this.activeSteps[stepIndex].status =
      this.activeSteps[stepIndex].status == 'inProgress'
        ? 'inComplete'
        : this.activeSteps[stepIndex].status;
    this.activeStep = this.activeSteps[stepIndex - 1].value;
    const toStep = this.activeSteps[stepIndex - 1];
    this.trackPlaceOrder('place-order:step:back', { fromStep: fromStep.label, toStep: toStep.label });
    this.trackPlaceOrder('place-order:step:entered', { fromStep: fromStep.label, navigation: 'back' });
  }

  onNext() {
    let stepIndex = _.findIndex(
      this.activeSteps,
      (item) => item.value == this.activeStep,
    );
    if (this.checkValidity(this.activeSteps[stepIndex])) {
      // Success - reset the flag
      if (this.orderInfoComponent) {
        this.orderInfoComponent.formSubmissionAttempted = false;
      }
      this.messageService.clear();
      if (this.CheckIfAttornySelected()) {
        this.messageService.clear();
        const fromStep = this.activeSteps[stepIndex];
        const toStep = this.activeSteps[stepIndex + 1];
        this.activeSteps[stepIndex].status = 'completed';
        this.activeStep = toStep.value;
        toStep.status = 'inProgress';
        this.trackPlaceOrder('place-order:step:next', { fromStep: fromStep.label, toStep: toStep.label });
        this.trackPlaceOrder('place-order:step:entered', { fromStep: fromStep.label, navigation: 'next' });
      }
    } else {
      // Validation failed - set the flag to show errors
      if (this.orderInfoComponent) {
        this.orderInfoComponent.formSubmissionAttempted = true;
      }
      this.messageService.clear();
      const failureMessage = this.invalidFormFields.length
        ? `${_.join(this.invalidFormFields, ', ')} is invalid. Please enter a valid value`
        : '';
      const errorMessage = this.invalidControls.length
        ? `${_.join(this.invalidControls, ', ')} is mandatory. Please fill out all the mandatory fields before proceeding\n`
        : '';
      this.messageService.add({
        severity: 'error',
        summary: ORDER_CATEGORY.TOAST_SUMMARY_ERROR,
        detail: `${errorMessage} ${failureMessage}`,
        sticky: true,
      });
      this.trackPlaceOrder('place-order:validation:failed', {
        reason: 'invalid-form',
        invalidControls: this.invalidControls.join(',')
      });
    }
    this.orderInfoComponent?.validate();
  }

  // Creates an updated payload for edit flow by merging persisted party data.
  updateEditPayload(payload: any): any {
    const updatedPayload = _.cloneDeep(payload);

    this.applyMergedPartiesToEditPayload(updatedPayload, payload);

    return updatedPayload;
  }

  // Applies merged case and retrieval parties into the cloned edit payload.
  private applyMergedPartiesToEditPayload(
    updatedPayload: any,
    payload: any,
  ): void {
    const mergedCaseParties = this.mergeSourceIntoTarget(
      payload?.data?.case?.parties,
      this.caseFileData.parties,
    );

    const mergedRetrievalParties = this.mergeSourceIntoTarget(
      payload?.data?.retrievalObjective?.parties,
      this.recordRetrievalObjectiveData.parties,
    );

    updatedPayload.data.case.parties = mergedCaseParties;
    updatedPayload.data.retrievalObjective.parties = mergedRetrievalParties;
  }

  // Merges source parties into target parties using internal id matching.
  mergeSourceIntoTarget(
    source: PartyEntry[],
    target: PartyEntry[],
  ): PartyEntry[] {
    const merged = [...(target || [])];

    for (const srcEntry of source || []) {
      const targetIndex = this.findTargetPartyIndexByInternalId(
        srcEntry,
        merged,
      );

      if (targetIndex === -1) {
        // No match: push new source entry into target
        merged.push(srcEntry);
        continue;
      }

      const tgtEntry = merged[targetIndex];
      this.mergePartyData(srcEntry.party, tgtEntry.party);
      this.mergeRoleData(srcEntry.roles?.[0], tgtEntry.roles?.[0]);
    }

    return merged;
  }

  // Finds matching target party index by comparing internal-id keys.
  private findTargetPartyIndexByInternalId(
    srcEntry: PartyEntry,
    merged: PartyEntry[],
  ): number {
    // Get internal-id from source party
    const srcPublicId = _.get(
      _.find(srcEntry.party.keys, { typeCode: 'internal-id' }),
      'components.internal-id',
    );

    // Find matching target party by internal-id
    return _.findIndex(merged, (t) => {
      const tgtPublicId = _.get(
        _.find(t.party.keys, { typeCode: 'internal-id' }),
        'components.internal-id',
      );
      return srcPublicId && tgtPublicId && srcPublicId === tgtPublicId;
    });
  }

  // Merges party-level fields like names, locators, type, and identity details.
  private mergePartyData(srcParty: any, tgtParty: any): void {
    if (!srcParty || !tgtParty) {
      return;
    }

    // === Update displayName if present ===
    if (srcParty.displayName) {
      tgtParty.displayName = srcParty.displayName;
    }

    // === Update party type code ===
    if (tgtParty?.typeCode) {
      switch (_.toUpper(tgtParty.typeCode)) {
        case 'P':
          tgtParty.typeCode = 'Person';
          break;
        case 'O':
          tgtParty.typeCode = 'Organization';
          break;
        case 'A':
          tgtParty.typeCode = 'Anonymous';
          break;
        default:
          break;
      }
    }

    // === 1. Merge person/organization ===
    if (srcParty.person) {
      tgtParty.person = {
        ...tgtParty.person,
        ...srcParty.person,
      };
    }

    if (srcParty.organization) {
      tgtParty.organization = {
        ...tgtParty.organization,
        ...srcParty.organization,
      };
    }

    // === 2. Merge names by function ===
    const nameMap = new Map(
      tgtParty.names?.map((n: any) => [_.toLower(n.function), n]) || [],
    );

    for (const srcName of srcParty.names || []) {
      const functionKey = _.toLower(srcName.function);
      const existing = nameMap.get(functionKey) || {};
      nameMap.set(functionKey, {
        ...existing,
        ...srcName,
      });
    }

    tgtParty.names = Array.from(nameMap.values());

    // === 3. Merge locators by typeCode + subkey (email/phone/location) purpose ===
    const locatorKey = (locator: any) => {
      const sub =
        locator.email?.purpose ||
        locator.phone?.purpose ||
        locator.location?.purpose ||
        '';
      return `${locator.typeCode}:${sub}`;
    };

    const locatorMap = new Map(
      (tgtParty.locators || []).map((l: any) => [locatorKey(l), l]),
    );

    for (const srcLocator of srcParty.locators || []) {
      const existingLocator = locatorMap.get(locatorKey(srcLocator)) || {};
      locatorMap.set(locatorKey(srcLocator), {
        ...existingLocator,
        ...srcLocator,
      });
    }

    tgtParty.locators = Array.from(locatorMap.values());
  }

  // Merges role-level fields for the primary role entry.
  private mergeRoleData(srcRole: any, tgtRole: any): void {
    if (!srcRole || !tgtRole) {
      return;
    }

    // === 4. Merge role-level data ===
    if (srcRole?.attorney) {
      tgtRole.attorney = { ...tgtRole.attorney, ...srcRole.attorney };
    }

    if (srcRole?.recordSubject) {
      tgtRole.recordSubject = {
        ...tgtRole.recordSubject,
        ...srcRole.recordSubject,
      };
    }

    if (srcRole?.court) {
      tgtRole.court = {
        ...tgtRole.court,
        ...srcRole.court,
      };
    }

    // Merge requestNumbers arrays (for existing requests)
    if (srcRole?.requestNumbers?.length) {
      const existing = new Set([...(tgtRole.requestNumbers || []), ...srcRole.requestNumbers]);
      tgtRole.requestNumbers = Array.from(existing);
    }

    // Merge requestUuids arrays (for new requests)
    if (srcRole?.requestUuids?.length) {
      const existing = new Set([...(tgtRole.requestUuids || []), ...srcRole.requestUuids]);
      tgtRole.requestUuids = Array.from(existing);
    }

    // Optional: Update `delete` flag if present in source
    if ('delete' in srcRole) {
      tgtRole.delete = srcRole.delete;
    }
  }

  onFinish() {
    this.isFormSubmitted = true;
    this.recordsComponent?.recordsFormGroup?.markAllAsTouched?.();
    this.recordsComponent?.recordsFormGroup?.markAsDirty?.();
    this.recordsComponent?.validateForm?.();
    let stepIndex = _.findIndex(
      this.activeSteps,
      (item) => item.value == this.activeStep,
    );
    if (this.checkValidity(this.activeSteps[stepIndex])) {
      this.messageService.clear();
      //check if all subjects are mapped to record
      if (!this.checkIfAllSubjectsMappedWithRequest()) {
        this.isFormSubmitted = false;
        return;
      }
      let requestPayload: OrderCreation;
      try {
        requestPayload = this.getSubmitOrderPayload();
      } catch (error) {
        if (!(error instanceof DocumentListValidationError)) throw error;
        this.isFormSubmitted = false;
        this.messageService.add({
          severity: 'error', summary: ORDER_CATEGORY.TOAST_SUMMARY_ERROR,
          detail: error.message, sticky: true,
        });
        return;
      }
      this.trackPlaceOrder('place-order:submit:attempted');
      if (this.isEditOrder) {
        const updatedPayload = this.updateEditPayload(requestPayload);

        const requestPayloadWithQualifiers: OrderUpdate = {
          customerReferenceNumber: updatedPayload?.customerReferenceNumber,
          summaryDescription: requestPayload.summaryDescription,
          orderedBy: requestPayload.orderedBy,
          qualifiers: updatedPayload?.qualifiers,
          data: updatedPayload?.data,
        };

        const updateOrder$ = this.orderService.updateOrder(
          API_CONTEXT.STANDARD,
          this.orderNumber,
          requestPayloadWithQualifiers as OrderUpdate,
        );
        updateOrder$.subscribe({
          next: (updateOrderResponse) => {
            this.placeOrderCompleted = true;
            this.trackPlaceOrder('place-order:submit:succeeded', { orderNumber: updateOrderResponse?.orderNumber });
            // Validate request number formats after successful order update
            this.validateRequestNumberFormat(updateOrderResponse);
            
            this.router.navigate(['/home/order-success'], {
              state: {
                orderNumber: updateOrderResponse?.orderNumber,
                orderedDate: updateOrderResponse?.orderedDate,
                incidentDate: this.orderInfoData?.orderInfoDate,
                claimNumber: this.orderInfoData?.orderInfoRefNum,
                isEditOrder: true,
              },
            });
          },
          error: (error) => this.handleOrderSubmitError(error),
          complete: () => this.handleOrderSubmitComplete(),
        });
      } else {
        this.orderService
          .createOrder(API_CONTEXT.STANDARD, requestPayload as OrderCreation)
          .subscribe({
            next: (res) => {
            this.placeOrderCompleted = true;
            this.trackPlaceOrder('place-order:submit:succeeded', { orderNumber: res?.orderNumber });
              // Validate request number formats after successful order creation
              this.validateRequestNumberFormat(res);
              
              this.router.navigate(['/home/order-success'], {
                state: {
                  orderNumber: res?.orderNumber,
                  orderedDate: res?.orderedDate,
                  incidentDate: this.orderInfoData?.orderInfoDate,
                  claimNumber: this.orderInfoData?.orderInfoRefNum,
                  isEditOrder: false,
                },
              });
            },
            error: (error) => this.handleOrderSubmitError(error),
            complete: () => this.handleOrderSubmitComplete(),
          });
      }
      // this.router.navigate(['/home/order-success'],{ state: { orderNumber: '123', orderedDate: '2025-03-12T08:43:57.307-04:00', incidentDate: this.orderInfoData?.orderInfoDate}});
    } else {
      this.isFormSubmitted = false;
      this.messageService.clear();
      const failureMessage = this.invalidFormFields.length
        ? `${_.join(this.invalidFormFields, ', ')} is invalid. Please enter a valid value`
        : '';
      const errorMessage = this.invalidControls.length
        ? `${_.join(this.invalidControls, ', ')} is mandatory. Please fill out all the mandatory fields before proceeding\n`
        : '';
      this.messageService.add({
        severity: 'error',
        summary: ORDER_CATEGORY.TOAST_SUMMARY_ERROR,
        detail: `${errorMessage} ${failureMessage}`,
        sticky: true,
      });
      this.trackPlaceOrder('place-order:validation:failed', {
        reason: 'invalid-form',
        invalidControls: this.invalidControls.join(',')
      });
    }
  }

  private handleOrderSubmitError(error: any): void {
    this.isFormSubmitted = false;
    this.trackPlaceOrder('place-order:submit:failed', { errorStatus: error?.status });
    this.messageService.add({
      severity: 'error',
      summary: ORDER_CATEGORY.TOAST_SUMMARY_ERROR,
      detail:
        'System error, please contact help desk at EXLRecords.Helpdesk@exlservice.com',
      sticky: true,
    });
  }

  private handleOrderSubmitComplete(): void {
    this.isFormSubmitted = false;
  }

  getInvalidControls(form: any, formArray: boolean = false) {
    if (!formArray) {
      this.invalidControls = [];
      this.invalidFormFields = [];
    }
    Object.keys(form.controls).forEach((controlName) => {
      var control = form.get(controlName);
      if (control && _.get(control, 'controls')) {
        if (Array.isArray(control.controls)) {
          control.controls.forEach((ctrl: any) =>
            this.getInvalidControls(ctrl, true),
          );
        } else {
          this.getInvalidControls(control, true);
        }
      } else if (control && control.invalid) {
        const label = control?.displayName || controlName;
        if (control.errors.required) {
          if (!this.invalidControls.includes(label)) {
            this.invalidControls.push(label);
          }
          //this.invalidControls.push(control?.displayName ? control?.displayName : controlName);  // Collect invalid control names
        } else {
          if (!this.invalidFormFields.includes(label)) {
            this.invalidFormFields.push(label);
            //this.invalidFormFields.push(control?.displayName ? control?.displayName : controlName);
          }
        }
      }
    });

    // Check for ssnSubjectMismatch error at the form group level
    if (form.errors && form.errors['ssnSubjectMismatch']) {
      this.invalidFormFields.push(
        `The SS# values for record subject${form.errors['ssnSubjectMismatch'].length > 1 ? 's' : ''} ${form.errors['ssnSubjectMismatch'].join(', ')}`,
      );
    }
  }

  setCurrentStep(step: Step) {
    if (step.status !== 'completed') return;
    this.messageService.clear();
    let stepIndex = _.findIndex(
      this.activeSteps,
      (item) => item.value == this.activeStep,
    );
    const fromStep = this.activeSteps[stepIndex];
    this.updateFormData(this.activeSteps[stepIndex]);

    this.activeSteps[stepIndex].status =
      this.activeSteps[stepIndex].status == 'inProgress'
        ? 'inComplete'
        : this.activeSteps[stepIndex].status;
    this.activeStep = step.value;
    this.trackPlaceOrder('place-order:step:jump', { fromStep: fromStep.label, toStep: step.label });
    this.trackPlaceOrder('place-order:step:entered', { fromStep: fromStep.label, navigation: 'jump' });
  }

  isLastStep() {
    return (
      this.activeStep === this.activeSteps[this.activeSteps.length - 1]?.value
    );
  }

  updateStepper(orderType: any) {
    switch (orderType) {
      case ORDER_CATEGORY.SUBPOENA_TO_BE_PREPARED:
        let stepIndex = _.findIndex(this.activeSteps, ['label', 'Subpoena']);
        let subpoenaStep = _.cloneDeep(_.find(steps, ['label', 'Subpoena']));
        if (stepIndex == -1 && subpoenaStep && this.subpoenaStepperRequired) {
          subpoenaStep.visible = true;
          this.activeSteps.splice(2, 0, subpoenaStep);
        }

        _.remove(this.activeSteps, ['label', 'Authorization']);
        break;
      case ORDER_CATEGORY.AUTHORIZATION_NOT_PROVIDED:
        let stepIndex2 = _.findIndex(this.activeSteps, [
          'label',
          'Authorization',
        ]);
        let authorizationStep = _.cloneDeep(
          _.find(steps, ['label', 'Authorization']),
        );
        if (stepIndex2 == -1 && authorizationStep) {
          authorizationStep.visible = true;
          this.activeSteps.splice(2, 0, authorizationStep);
        }
        _.remove(this.activeSteps, ['label', 'Subpoena']);
        break;
      default:
        _.remove(this.activeSteps, ['label', 'Subpoena']);
        _.remove(this.activeSteps, ['label', 'Authorization']);
    }
  }

  // Validates the current step form and stores form values.
  checkValidity(step: Step) {
    switch (step.label) {
      case 'Order Info':
        this.orderInfoData = this.orderInfoComponent.formGroup.getRawValue();
        this.orderInfoComponent.validate();
        if (!this.orderInfoComponent.formGroup.valid) {
          this.orderInfoComponent.formGroup.markAllAsTouched();
          this.getInvalidControls(this.orderInfoComponent.formGroup);
        }
        // return true;
        return this.orderInfoComponent.formGroup.valid;
        break;
      case 'Subjects':
        this.subjectsData = this.subjectsComponent.formGroup.value;
        const subjectsArray = this.subjectsComponent.formGroup.get(
          'subjects',
        ) as FormArray;
        //Clear maxDateExceeded validation errors for empty dateOfDeath fields
        subjectsArray.controls.forEach((subjectGroup: AbstractControl) => {
          const dodControl = subjectGroup.get('dateOfDeath');
          if (!dodControl?.value) {
            dodControl?.setErrors(null);
          }
        });

        if (!this.subjectsComponent.formGroup.valid) {
          this.subjectsComponent.formGroup.markAllAsTouched();
          this.subjectsComponent.formGroup.updateValueAndValidity();
          this.getInvalidControls(this.subjectsComponent.formGroup);
        }
        // return true;
        return this.subjectsComponent.formGroup.valid;
        break;
      case 'Subpoena':
        this.subpoenaData = this.subpoenaComponent.formGroup.value;
        if (!this.subpoenaComponent.formGroup.valid) {
          this.subpoenaComponent.formGroup.markAllAsTouched();
          this.getInvalidControls(this.subpoenaComponent.formGroup);
        }
        // return true;
        return this.subpoenaComponent.formGroup.valid;
        break;
      case 'Authorization':
        this.authorizationData = this.authorizationComponent.formGroup.value;
        if (!this.authorizationComponent.formGroup.valid) {
          this.authorizationComponent.formGroup.markAllAsTouched();
          this.getInvalidControls(this.authorizationComponent.formGroup);
        }
        // return true;
        return this.authorizationComponent.formGroup.valid;
        break;
      case 'Records':
        this.recordsData = this.recordsComponent.recordsFormGroup.value;
        if (!this.recordsComponent.recordsFormGroup.valid) {
          this.recordsComponent.recordsFormGroup.markAllAsTouched();
          this.recordsComponent.validateForm();
          this.getInvalidControls(this.recordsComponent.recordsFormGroup);
        }
        return this.recordsComponent.recordsFormGroup.valid;
      default:
        return true;
    }
  }

  // Persists form data for the specified step into component state.
  updateFormData(step: Step) {
    switch (step.label) {
      case 'Order Info':
        this.orderInfoData = this.orderInfoComponent.formGroup.getRawValue();
        break;
      case 'Subjects':
        this.subjectsData = this.subjectsComponent.formGroup.value;
        break;
      case 'Subpoena':
        this.subpoenaData = this.subpoenaComponent.formGroup.value;
        break;
      case 'Authorization':
        this.authorizationData = this.authorizationComponent.formGroup.value;
        break;
      case 'Records':
        this.recordsData = this.recordsComponent.recordsFormGroup.value;
    }
  }

  onFormChange() {
    let currentStep = _.find(this.activeSteps, ['value', this.activeStep]);
    if (currentStep && currentStep.status == 'completed') {
      currentStep.status = 'inProgress';
      _.forEach(this.activeSteps, (step) => {
        if (currentStep && step.value > currentStep.value) {
          step.status = 'none';
        }
      });
    }
  }

  getFormatedDate(date: any) {
    if (!date) return '';

    const parsedDate = new Date(date);

    // Check if date is valid
    if (isNaN(parsedDate.getTime())) {
      console.error('Invalid date:', parsedDate);
      return '';
    }

    return parsedDate?.toISOString();
  }

  getDurationToMinutesSeconds(durationMs: number): string {
    const totalSeconds = Math.floor(durationMs / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    const paddedMinutes = minutes.toString().padStart(2, '0');
    const paddedSeconds = seconds.toString().padStart(2, '0');

    return `${paddedMinutes}:${paddedSeconds}`;
  }

  getSubmitOrderPayload(): OrderCreation {
    const completionDateTime = new Date();

    // Preserve builder call order to keep side-effects and behavior unchanged.
    const caseObject = this.buildCaseObjectPayload();
    const retrievalObjective = this.buildRetrievalObjectivePayload();

    return this.buildOrderCreationPayload(
      caseObject,
      retrievalObjective,
      completionDateTime,
    );
  }

  private buildOrderCreationPayload(
    caseObject: CaseFileItemCreation,
    retrievalObjective: RecordRetrievalObjectiveItemCreation,
    completionDateTime: Date,
  ): OrderCreation {
    return {
      typeCode: ORDER_CATEGORY.RECORD_RETRIEVAL,
      customerReferenceNumber: this.orderInfoData?.orderInfoRefNum,
      customerId: this.orderInfoData?.orderInfoClientName,
      summaryDescription:
        this.orderInfoData?.orderInfoRefNum +
        ':' +
        this.orderInfoData?.selectedCategory,
      qualifiers: this.buildOrderQualifiers(completionDateTime),
      data: {
        case: caseObject,
        retrievalObjective: retrievalObjective,
        contacts: this.newContactsForContactBook,
      },
      orderedByAccountId: this.orderInfoData?.orderInfoAccountName,
      orderedBy: this.orderInfoData?.orderInfoOrderOwner,
    };
  }

  // Builds the case object section for order payload.
  private buildCaseObjectPayload(): CaseFileItemCreation {
    const caseObject: CaseFileItemCreation = {
      typeCode: 'civil',
      caseName: this.subpoenaData?.caseName,
      caseNumber: this.subpoenaData?.caseNumber
        ? this.subpoenaData?.caseNumber
        : (this.authorizationData?.caseNumber ?? ''),
      referenceNumber: this.orderInfoData?.orderInfoRefNum,
      incidentDate: this.getFormatedDate(this.orderInfoData?.orderInfoDate),
      firmCode: this.orderInfoData?.orderInfoAccountName,
      clientCode: this.orderInfoData?.orderInfoClientName,
      parties: this.getCaseParties(),
      partyRelationships: this.partyRelationships,
    } as CaseFileItemCreation;

    (caseObject as any).qualifiers = {
      ...(caseObject as any).qualifiers,
      caseMatter: this.orderInfoData?.caseMatter,
    };

    return caseObject;
  }

  // Builds the retrieval objective section and request entries.
  private buildRetrievalObjectivePayload(): RecordRetrievalObjectiveItemCreation {
    const retrievalObjective: RecordRetrievalObjectiveItemCreation = {
      orderTypeCode: this.orderInfoData?.selectedCategory,
      accountId: this.orderInfoData?.orderInfoAccountName,
      serviceLevelCode: this.orderInfoData?.selectedLevel
        ? SERVICE_LEVEL.RUSH
        : SERVICE_LEVEL.NORMAL,
      specialInstructions: this.orderInfoData?.orderInfoSpecialInstructions,
      customerId: this.orderInfoData?.orderInfoClientName,
      parties: this.getRetrievalObjectiveParties(),
      documentLists: buildDocumentLists(
        (this.orderInfoData?.orderInfoAttachmentFile ?? [])
          .filter(item => !this.isEditOrder || item.isNew === true)
          .map(item => ({ ...item, description: item.filename })),
        'order',
      ),
      qualifiers: {
        orderedByAccountId: this.orderInfoData?.orderInfoAccountName,
      },
    } as RecordRetrievalObjectiveItemCreation;

    retrievalObjective.requests = this.getRetrievalObjectiveRequest(
      retrievalObjective.parties,
    );

    return retrievalObjective;
  }

  // Builds order qualifier values such as timing and plaintiff details.
  private buildOrderQualifiers(
    completionDateTime: Date,
  ): Record<string, string> {
    return {
      orderType: this.orderInfoData?.selectedCategory as string,
      incidentDate: this.getFormatedDate(this.orderInfoData?.orderInfoDate),
      plaintiffName: this.subjectsData?.subjects
        ?.map((item) => item.recordSubjectName)
        ?.join(',') as string,
      orderStartTime: this.orderStartDateTime.toISOString(),
      orderEndTime: completionDateTime.toISOString(),
      timeToCompleteOrder: this.getDurationToMinutesSeconds(
        completionDateTime.getTime() - this.orderStartDateTime.getTime(),
      ),
    };
  }

  // Appends request number to role request list while preserving existing values.
  private appendRoleRequestNumber(
    role: RecordRetrievalPartyRoleItemCreation | undefined,
    requestUuid: string,
  ): void {
    if (!role) return;
    (role.requestUuids ??= []).push(requestUuid);
  }
 

  // Creates case party shell by party type.
  getCasePartyByTypeCode(code: PartyTypeCode, displayName: any, data?: any) {
    return this.partyFactoryService.getCasePartyByTypeCode(
      code,
      displayName,
      data,
    );
  }

  // Builds retrieval requests and links them to record-subject party roles.
  getRetrievalObjectiveRequest(parties?: RecordRetrievalPartyItemCreation[]) {
    let requests: RecordRetrievalRequestItemCreation[] = [];
    _.forEach(this.recordsData?.records, (item) => {
      let request: RecordRetrievalRequestItemCreation = {
        documentLists: buildDocumentLists(
          (item.orderInfoAttachmentFile ?? [])
            .filter(file => !this.isEditOrder || file.isNew === true)
            .map(file => ({ ...file, description: file.filename })),
          { request: item },
        ),
      };
      let updatedSSN: string = '';
      let ssnLocator: PartyLocatorCreation = {};
      // Set UUID on every new request - backend will assign requestNumber after creation
      if (item.requestNumber) {
        request.requestNumber = item.requestNumber;
      } else {
        request.requestUuid = item.requestUuid;
      }
      // Set parentRequestNumber only for split children
      if (item.parentRequestNumber) {
        request.parentRequestNumber = item.parentRequestNumber;
      }
      request.notes = item.notesTextarea;
      request.subpoenaLanguage = item.subpoenaLanguageTextarea;
      request.scope = [];
      _.forEach(item.selectedTypes, (type) => {
        const scopeResult = this.buildRequestScope(type, item);
        if (scopeResult.updatedSSN) {
          updatedSSN = scopeResult.updatedSSN;
        }
        if (scopeResult.ssnLocator?.typeCode) {
          ssnLocator = scopeResult.ssnLocator;
        }

        request.scope?.push(scopeResult.scope);
      });
      requests.push(request);

      //record subject parties for requests
      this.updateRecordSubjectPartyForRequest(
        parties,
        item.subject,
        item.requestNumber
          ? { kind: 'number', value: item.requestNumber }
          : { kind: 'uuid', value: item.requestUuid! },
        updatedSSN,
        ssnLocator,
      );
    });

    return requests;
  }

  private buildRequestScope(
    type: string,
    item: any,
  ): {
    scope: RecordRetrievalRequestRecordScopeItemCreation;
    updatedSSN?: string;
    ssnLocator?: PartyLocatorCreation;
  } {
    const scope: RecordRetrievalRequestRecordScopeItemCreation = {
      recordTypeCode: type,
      beginDate: this.getFormatedDate(item.dateToServiceFrom) ?? '',
      endDate: this.getFormatedDate(item.dateToServiceTo) ?? '',
    };

    let updatedSSN: string | undefined;
    let ssnLocator: PartyLocatorCreation | undefined;

    switch (type) {
      case 'diagnostic-images':
        scope.qualifiers = {
          diagnosticTypeCodes: item.diagnosticImages?.typesOfImaging
            ? _.join(
                _.uniq(
                  _.filter(
                    _.map(item.diagnosticImages?.typesOfImaging, 'name'),
                    (name) => _.trim(name) !== '',
                  ),
                ),
                ',',
              )
            : '',
          diagnosticFocusArea: item.diagnosticImages?.specificBodyPart,
          diagnosticComments: item.diagnosticImages?.other,
        };
        break;
      case 'ambulance':
        scope.qualifiers = {
          ambulanceDateOfService: this.getFormatedDate(item.ambulance?.date),
          ambulanceTimeOfService: item.ambulance?.time,
          ambulancePickupLine1: item.ambulance?.pickupAddress,
          ambulancePickupCity: item.ambulance?.pickupCity,
          ambulancePickupState: item.ambulance?.pickupState?.value,
          ambulancePickupPostal: item.ambulance?.pickupZip,
          ambulanceDropOffLine1: item.ambulance?.dropAddress,
          ambulanceDropOffCity: item.ambulance?.dropCity,
          ambulanceDropOffState: item.ambulance?.dropState?.value,
          ambulanceDropOffPostal: item.ambulance?.dropZip,
        };
        break;
      case 'insurance':
        scope.qualifiers = {
          insuranceClaimNumber: item.insurance?.claimNumber,
          insurancePolicyNumber: item.insurance?.policyNumber,
        };
        break;
      case 'military':
        scope.qualifiers = {
          militaryBranch: item.military?.branch,
          militaryServiceNumber: item.military?.serviceNumber,
        };
        break;
      case 'union':
        scope.qualifiers = {
          unionMembershipNumber: item.union?.membershipNumber,
        };
        break;
      case 'va':
        scope.qualifiers = {
          vaMedicalRecords: item.va?.medical[0] || '',
          vaBenefitRecords: item.va?.benefit[0] || '',
        };
        break;
      case 'other':
        scope.qualifiers = {
          otherDescriptionOfRecords: item.other?.descriptionOfRecords,
        };
        break;
      case 'employment':
        updatedSSN = item.employment?.employmentSS;
        break;
      case 'irs':
        updatedSSN = item.irs?.irsSS;
        break;
      case 'social-security':
        updatedSSN = item.socialSecurity?.socialSecuritySS;
        if (
          this.partyFactoryService.checkAddressValid(
            item.socialSecurity?.address,
            item.socialSecurity?.city,
            item.socialSecurity?.state?.value,
            item.socialSecurity?.zip,
          )
        ) {
          ssnLocator = this.partyFactoryService.getLocationLocator(
            item.socialSecurity?.address,
            item.socialSecurity?.city,
            item.socialSecurity?.state?.value,
            item.socialSecurity?.zip,
          );
        }
        break;
    }

    return { scope, updatedSSN, ssnLocator };
  }

  private updateRecordSubjectPartyForRequest(
    parties: RecordRetrievalPartyItemCreation[] | undefined,
    subject: string,
    requestRef: RequestRef,
    updatedSSN: string,
    ssnLocator: PartyLocatorCreation,
  ): void {
    const recordSubjectParty = _.find(
      parties,
      (party: RecordRetrievalPartyItemCreation) => {
        return (
          party.party?.displayName == subject &&
          _.some(party.roles, ['roleCode', PartyRoleCode.RecordSubject])
        );
      },
    );

    if (!recordSubjectParty) {
      return;
    }

    const role = _.find(recordSubjectParty.roles, [
      'roleCode',
      PartyRoleCode.RecordSubject,
    ]);
    // Accumulate all request UUIDs into the ONE record-subject entry
    if (role) {
      this.partyFactoryService.appendRequestRefToSubjectRole(
        role,
        requestRef,
      );
    } else {
      console.error('Record subject role not found for request:', requestRef.value);
    }

    if (updatedSSN && updatedSSN.length > 0 && role?.recordSubject) {
      role.recordSubject.socialSecurityNumber = updatedSSN;
    }
    if (ssnLocator?.typeCode) {
      recordSubjectParty.party?.locators?.push(ssnLocator);
    }
  }

  // Builds retrieval objective parties including bill-to, adjuster, subjects, and providers.
  getRetrievalObjectiveParties() {
    let parties: RecordRetrievalPartyItemCreation[] = [];

    //bill-to
    let billParty = this.partyFactoryService.getRetrievalObjectivePartyByTypeCode(
      PartyTypeCode.Organization,
      this.orderInfoData?.orderInfoBillTo,
    );
    if (this.orderInfoData?.orderInfoBillToEmail) {
      billParty?.party?.locators?.push(
        this.partyFactoryService.getEmailLocator(this.orderInfoData?.orderInfoBillToEmail),
      );
    }

    billParty.roles = [];
    billParty?.roles?.push(this.partyFactoryService.getRole(PartyRoleCode.BillTo));

    if (billParty.party) {
      billParty.party.keys = billParty.party.keys || [];
      billParty.party.keys = this.CreateUUIDService.generatePartyExternalId(
        this.orderInfoData?.orderInfoBillingToKeys,
      );
    }
    parties.push(billParty);

    if (
      this.isEditOrder === false &&
      this.orderInfoData?.adjusterDropdown === null
    ) {
      const newContact = this.buildContactBookContact(
        this.orderInfoData?.orderInfoAdjusterName ?? '',
        'adjuster',
        '',
        [this.partyFactoryService.getEmailLocator(this.orderInfoData?.orderInfoAdjusterEmail)],
      );
      this.addContactToContactBook(
        this.orderInfoData?.clientContactListId ?? '',
        newContact,
      );
    }

    //adjuster
    let adjusterParty = this.partyFactoryService.getRetrievalObjectivePartyByTypeCode(
      PartyTypeCode.Person,
      this.orderInfoData?.orderInfoAdjusterName,
    );
    if (this.orderInfoData?.orderInfoAdjusterEmail) {
      adjusterParty?.party?.locators?.push(
        this.partyFactoryService.getEmailLocator(this.orderInfoData?.orderInfoAdjusterEmail),
      );
    }
    adjusterParty.roles = [];
    adjusterParty?.roles?.push(this.partyFactoryService.getRole(PartyRoleCode.Adjuster));
    if (adjusterParty.party) {
      adjusterParty.party.keys = adjusterParty.party.keys || [];
      adjusterParty.party.keys = this.CreateUUIDService.generatePartyExternalId(
        this.orderInfoData?.orderInfoAdjusterKeys,
      );
    }
    parties.push(adjusterParty);

    //deliver-to
    if (this.orderInfoData?.orderInfoAttentionToFirmName) {
      let deliverToParty = this.partyFactoryService.getRetrievalObjectivePartyByTypeCode(
        PartyTypeCode.Organization,
        this.orderInfoData.orderInfoAttentionToFirmName,
      );
      deliverToParty.party?.names?.push({
        function: 'contact-name',
        text: this.orderInfoData.orderInfoAttentionTo,
      });
      // deliverToParty?.party?.locators?.push(this.getEmailLocator(this.orderInfoData.orderInfoBillToEmail));
      deliverToParty?.party?.locators?.push(
        this.partyFactoryService.getPhoneLocator(
          this.orderInfoData.orderInfoAttentionToFirmPhone,
          this.orderInfoData.orderInfoAttentionToFirmPhoneExtn,
        ),
      );
      if (
        this.partyFactoryService.checkAddressValid(
          this.orderInfoData.orderInfoAttentionToFirmAddress,
          this.orderInfoData.orderInfoAttentionToFirmCity,
          this.orderInfoData.orderInfoAttentionToFirmState?.value,
          this.orderInfoData.orderInfoAttentionToFirmZip,
        )
      )
        deliverToParty?.party?.locators?.push(
          this.partyFactoryService.getLocationLocator(
            this.orderInfoData.orderInfoAttentionToFirmAddress,
            this.orderInfoData.orderInfoAttentionToFirmCity,
            this.orderInfoData.orderInfoAttentionToFirmState?.value,
            this.orderInfoData.orderInfoAttentionToFirmZip,
          ),
        );

      deliverToParty.roles = [];
      deliverToParty?.roles?.push(this.partyFactoryService.getRole(PartyRoleCode.DeliverTo));
      if (deliverToParty.party) {
        deliverToParty.party.keys = deliverToParty.party.keys || [];
        deliverToParty.party.keys =
          this.CreateUUIDService.generatePartyExternalId(
            this.orderInfoData?.orderInfoAttentionToKeys,
          );
      }
      parties.push(deliverToParty);
    }

    //subjects
    _.forEach(this.subjectsData?.subjects, (item) => {
      let subjectParty = this.partyFactoryService.getRetrievalObjectivePartyByTypeCode(
        PartyTypeCode.Person,
        item.recordSubjectName,
        item.alias,
      );
      if (subjectParty?.party) {
        subjectParty.party.person = {
          // dateOfBirth: _.toString(this.datePipe.transform(this.getFormatedDate(item.dateOfBirth), 'yyyy-MM-dd', 'UTC')),
          // dateOfDeath: _.toString(this.datePipe.transform(this.getFormatedDate(item.dateOfDeath), 'yyyy-MM-dd', 'UTC'))
          dateOfBirth: this.dateUtilService.formatCalendarDateForApi(
            item.dateOfBirth,
          ),
          dateOfDeath: this.dateUtilService.formatCalendarDateForApi(
            item.dateOfDeath,
          ),
        };
      }

      subjectParty.roles = [];
      let tempRole = this.partyFactoryService.getRole(
        PartyRoleCode.RecordSubject,
      ) as RecordRetrievalPartyRoleItemCreation;
      tempRole.recordSubject = {
        socialSecurityNumber: _.toString(item.ssn),
      };
      subjectParty?.roles?.push(tempRole);

      if (subjectParty.party) {
        subjectParty.party.keys = subjectParty.party.keys || [];
        subjectParty.party.keys =
          this.CreateUUIDService.generatePartyExternalId(item.keys);
      }
      parties.push(subjectParty);
    });

    //records - use factory methods with RequestRef for proper UUID/number handling
    let recordParties: RecordRetrievalPartyItemCreation[] = [];
    _.forEach(this.recordsData?.records, (item) => {
      // Every new record in create flow always uses UUID
      const ref: RequestRef = item.requestNumber
        ? { kind: 'number', value: item.requestNumber }
        : { kind: 'uuid', value: item.requestUuid! };

      // ONE separate party entry per record — this is the correct pattern
      recordParties.push(this.partyFactoryService.buildRecordsCustodianParty(item, ref));

      if (item.doctor && item.doctor.length > 0) {
        recordParties.push(this.partyFactoryService.buildMedicalProviderParty(item, ref));
      }
    });

    // let recordParties: RecordRetrievalPartyItemCreation[] = [];
    // _.forEach(this.recordsData?.records, (item, index) => {
    //   let providerExists =  _.some(recordParties, recordParty => {
    //     return recordParty.party?.displayName == item.providerName
    //   });

    //   if(!providerExists) {
    //     let recordsCustodianParty = this.createNewRecordCustodianParty(item, index);
    //     recordParties.push(recordsCustodianParty);

    //     if (item.doctor && item.doctor.length > 0) {
    //       let medicalProviderParty = this.createNewMedicalProviderParty(item, index);
    //       recordParties.push(medicalProviderParty);
    //     }
    //   } else {
    //     //update existing providers request number array
    //     let recordsCustodianParty = _.find(recordParties, (party: RecordRetrievalPartyItemCreation) => {
    //       return party.party?.displayName == item.providerName && _.some(party.roles,['roleCode', PartyRoleCode.RecordsCustodian]);
    //     });

    //     if(recordsCustodianParty) {
    //       let role = _.find(recordsCustodianParty.roles,['roleCode', PartyRoleCode.RecordsCustodian]);
    //       if(role && role?.requestNumbers) {
    //         role?.requestNumbers?.push(`${index+1}`);
    //       } else if (role){
    //         role.requestNumbers = [`${index+1}`];
    //       }
    //     }

    //     //check if doctor exist for the existing provider by comparing request no of provider and doctor
    //     if (item.doctor && item.doctor.length > 0) {
    //       let existingDoctorParties = _.filter(recordParties, recordParty => {
    //         return recordParty.party?.displayName == item.doctor
    //       });

    //       const currentProviderRequestNumbers = new Set(
    //         recordsCustodianParty?.roles?.flatMap(role => role.requestNumbers)
    //       );

    //       const matchingDoctorParty = existingDoctorParties?.find(doctor =>
    //         doctor?.roles?.some(role =>
    //           role?.requestNumbers?.some(reqNum => currentProviderRequestNumbers.has(reqNum))
    //         )
    //       );

    //       if (matchingDoctorParty) {
    //         let role = _.find(matchingDoctorParty.roles,['roleCode', PartyRoleCode.MedicalProvider]);
    //         if(role && role?.requestNumbers) {
    //           role?.requestNumbers?.push(`${index+1}`);
    //         } else if (role){
    //           role.requestNumbers = [`${index+1}`];
    //         }
    //       } else {
    //         let medicalProviderParty = this.createNewMedicalProviderParty(item, index);
    //         recordParties.push(medicalProviderParty);
    //       }
    //     }
    //   }
    // });

    return _.concat(parties, recordParties);
  }


  // Builds all case parties and relationships from order step data.
  getCaseParties() {
    const parties: CaseFilePartyItemCreation[] = [];

    this.addContactCaseParties(parties);
    this.addAuthorizationCaseParties(parties);
    this.addSubpoenaCaseParties(parties);

    return parties;
  }

  private addContactCaseParties(parties: CaseFilePartyItemCreation[]): void {
    _.forEach(this.orderInfoData?.contacts, (item) => {
      if (this.shouldCreateContactBookEntry(item)) {
        const newContact = this.buildContactBookContact(
          item.contactName ?? '',
          item.contactTitle.value,
          item.contactBarNo ?? '',
          [
            this.partyFactoryService.getPhoneLocator(item.contactPhone, item.contactPhoneExtn),
            this.partyFactoryService.getEmailLocator(item.contactEmail),
          ],
        );
        this.addContactToContactBook(
          this.orderInfoData?.accountContactListId ?? '',
          newContact,
        );
      }

      const party: CaseFilePartyItemCreation = this.getCasePartyByTypeCode(
        PartyTypeCode.Person,
        item.contactName,
        item.contactTitle.value,
      );
      party?.party?.locators?.push(this.partyFactoryService.getEmailLocator(item.contactEmail));
      party?.party?.locators?.push(
        this.partyFactoryService.getPhoneLocator(item.contactPhone, item.contactPhoneExtn),
      );
      party.roles = [];
      party.roles.push(
        this.partyFactoryService.getRole(
          item.contactTitle.value as PartyRoleCode,
          item.contactBarNo,
        ),
      );

      if (party.party) {
        party.party.keys = party.party.keys || [];
        party.party.keys = this.CreateUUIDService.generatePartyExternalId(
          item.keys,
        );
      }

      parties.push(party);
    });
  }

  private shouldCreateContactBookEntry(item: any): boolean {
    return item.isNew === true && item.showContactDropdown === false;
  }

  private addAuthorizationCaseParties(
    parties: CaseFilePartyItemCreation[],
  ): void {
    if (!this.authorizationData) {
      return;
    }

    _.forEach(this.authorizationData.authorizations, (item) => {
      const authorizationParty = this.buildCounselCaseParty(
        item.opposingCounselFirmName,
        item.opposingCounselAttorneyName,
        item.email,
        item.phone,
        item.extn,
        item.fax,
        item.streetAddress,
        item.city,
        item.state?.value,
        item.zip,
        PartyRoleCode.PlaintiffAttorney,
        item.opposingCounselBarNumer,
        item.keys,
      );
      parties.push(authorizationParty);

      _.forEach(item.recordSubjectName, (representing) => {
        const representingParty =
          this.createAuthorizationRepresentingParty(representing);
        parties.push(representingParty);
        this.addRepresentsRelationship(
          authorizationParty?.party?.keys,
          representingParty?.party?.keys,
        );
      });
    });
  }

  private createAuthorizationRepresentingParty(
    representing: any,
  ): CaseFilePartyItemCreation {
    const representingParty: CaseFilePartyItemCreation =
      this.getCasePartyByTypeCode(PartyTypeCode.Person, representing.name);
    representingParty.roles = [];
    representingParty?.roles?.push(this.partyFactoryService.getRole(PartyRoleCode.Plaintiff, ''));

    if (representingParty.party) {
      const validKeys =
        Array.isArray(representing?.keys) &&
        representing.keys.length > 0 &&
        representing.keys.every((k: any) => typeof k === 'object' && k !== null)
          ? representing.keys
          : [];

      representingParty.party.keys = validKeys;
      representingParty.party.keys =
        this.CreateUUIDService.generatePartyExternalId(validKeys);
    }

    return representingParty;
  }

  private addSubpoenaCaseParties(parties: CaseFilePartyItemCreation[]): void {
    if (!this.subpoenaData) {
      return;
    }

    this.addPlaintiffCounselCaseParties(parties);
    this.addDefendantCounselCaseParties(parties);
    this.addCourtCaseParty(parties);
  }

  private addPlaintiffCounselCaseParties(
    parties: CaseFilePartyItemCreation[],
  ): void {
    _.forEach(this.subpoenaData?.plaintiffCounseals, (item) => {
      const plaintiffCounselParty = this.buildCounselCaseParty(
        item.plantiffCounselFirmName,
        item.plantiffCounselAttorneyName,
        item.email,
        item.phone,
        item.extn,
        item.fax,
        item.streetAddress,
        item.city,
        item.state?.value,
        item.zip,
        PartyRoleCode.PlaintiffAttorney,
        item.plantiffCounselBarNumer,
        item.keys,
      );
      parties.push(plaintiffCounselParty);

      _.forEach(item.plaintiffs, (plantiff) => {
        const plaintiffParty = this.getOrCreateNamedPersonParty(
          parties,
          plantiff.name,
          PartyRoleCode.Plaintiff,
          plantiff.keys,
        );

        this.addRepresentsRelationship(
          plaintiffCounselParty?.party?.keys,
          plaintiffParty?.party?.keys,
        );
      });
    });
  }

  private addDefendantCounselCaseParties(
    parties: CaseFilePartyItemCreation[],
  ): void {
    _.forEach(this.subpoenaData?.defendantCounseals, (item) => {
      if (this.shouldUseExistingDefendantAttorney(item)) {
        const defAttKey = this.findDefendantAttorneyExternalId(parties);
        _.forEach(item.defendants, (defendant) => {
          const defendantParty = this.getOrCreateNamedPersonParty(
            parties,
            defendant.name,
            PartyRoleCode.Defendant,
            defendant.keys,
          );

          this.addRepresentsRelationshipByExternalId(
            defAttKey,
            defendantParty?.party?.keys,
          );
        });
        return;
      }

      const defendantCounselParty = this.buildCounselCaseParty(
        item.defendantCounselFirmName,
        item.defendantCounselAttorneyName,
        item.email,
        item.phone,
        item.extn,
        item.fax,
        item.streetAddress,
        item.city,
        item.state?.value,
        item.zip,
        PartyRoleCode.CoDefendantAttorney,
        item.defendantCounselBarNumer,
        item.keys,
      );
      parties.push(defendantCounselParty);

      _.forEach(item.defendants, (defendant) => {
        const defendantParty = this.getOrCreateNamedPersonParty(
          parties,
          defendant.name,
          PartyRoleCode.Defendant,
          defendant.keys,
        );

        this.addRepresentsRelationship(
          defendantCounselParty?.party?.keys,
          defendantParty?.party?.keys,
        );
      });
    });
  }

  private shouldUseExistingDefendantAttorney(item: any): boolean {
    return (
      (item?.defendantCounselFirmName === undefined ||
        item.defendantCounselFirmName ===
          this.orderInfoData?.orderInfoAccountName) &&
      (item.defendantCounselAttorneyName == null ||
        item.defendantCounselAttorneyName == '')
    );
  }

  private findDefendantAttorneyExternalId(
    parties: CaseFilePartyItemCreation[],
  ): any {
    let defAttKey: any;
    _.forEach(parties, (party) => {
      if (
        party.roles?.find(
          (role) => role.roleCode === PartyRoleCode.DefendantAttorney,
        )
      ) {
        if (party.party) {
          party.party.keys = party.party.keys || [];
          defAttKey = this.CreateUUIDService.getPartyExternalId(
            party.party.keys,
          );
        }
      }
    });
    return defAttKey;
  }

  private addCourtCaseParty(parties: CaseFilePartyItemCreation[]): void {
    const party: CaseFilePartyItemCreation = this.getCasePartyByTypeCode(
      PartyTypeCode.Organization,
      this.subpoenaData?.court,
    );
    if (
      this.partyFactoryService.checkAddressValid(
        this.subpoenaData?.courtStreetAddress,
        this.subpoenaData?.cityName,
        this.subpoenaData?.state?.value,
        this.subpoenaData?.zipCode,
      )
    ) {
      party.party?.locators?.push(
        this.partyFactoryService.getLocationLocator(
          this.subpoenaData?.courtStreetAddress ?? '',
          this.subpoenaData?.cityName ?? '',
          this.subpoenaData?.state?.value ?? '',
          this.subpoenaData?.zipCode ?? '',
        ),
      );
    }

    party.roles = [];
    party?.roles?.push(
      this.partyFactoryService.getRole(PartyRoleCode.Court, {
        item1: this.subpoenaData?.judge,
        item2: this.subpoenaData?.jurisdictionCounty,
      }),
    );
    this.setGeneratedPartyKeys(party, this.subpoenaData?.courtKeys);
    parties.push(party);
  }

  private buildCounselCaseParty(
    firmName: any,
    attorneyName: any,
    email: any,
    phone: any,
    extn: any,
    fax: any,
    streetAddress: any,
    city: any,
    state: any,
    zip: any,
    roleCode: PartyRoleCode,
    barNumber: any,
    keys: any,
  ): CaseFilePartyItemCreation {
    const counselParty: CaseFilePartyItemCreation = this.getCasePartyByTypeCode(
      PartyTypeCode.Organization,
      firmName,
      attorneyName,
    );

    counselParty.party?.locators?.push(this.partyFactoryService.getEmailLocator(email));
    counselParty.party?.locators?.push(this.partyFactoryService.getPhoneLocator(phone, extn));
    counselParty.party?.locators?.push(this.partyFactoryService.getFaxLocator(fax));

    if (this.partyFactoryService.checkAddressValid(streetAddress, city, state, zip)) {
      counselParty.party?.locators?.push(
        this.partyFactoryService.getLocationLocator(streetAddress, city, state, zip),
      );
    }

    counselParty.roles = [];
    counselParty?.roles?.push(this.partyFactoryService.getRole(roleCode, barNumber));
    this.setGeneratedPartyKeys(counselParty, keys);

    return counselParty;
  }






 

  setBreadcrumbPath() {
    this.sharedService.updateBreadcrumbPath([{ label: 'Place Order' }]);
  }

  onAddProviderValidate() {
    this.getInvalidControls(this.recordsComponent.recordsFormGroup);
    this.messageService.clear();
    const errorMessage = this.invalidControls.length
      ? `${_.join(this.invalidControls, ', ')} is mandatory. `
      : '';
    this.messageService.add({
      severity: 'error',
      summary: ORDER_CATEGORY.TOAST_SUMMARY_ERROR,
      detail: `${errorMessage}Please fill out all the mandatory fields before proceeding`,
      sticky: true,
    });
    this.trackPlaceOrder('place-order:validation:failed', {
      reason: 'add-provider',
      invalidControls: this.invalidControls.join(',')
    });
  }

  // Ensures every selected subject has at least one mapped request.
  checkIfAllSubjectsMappedWithRequest(): boolean {
    const subjects = this.subjectsData?.subjects || [];
    const records = this.recordsData?.records || [];

    const unmappedSubjects = subjects
      .filter(
        (subject) =>
          !records.some(
            (record) =>
              record?.subject?.toLowerCase() ===
              subject?.recordSubjectName?.toLowerCase(),
          ),
      )
      .map((subject) => subject.recordSubjectName);

    if (unmappedSubjects.length) {
      this.messageService.add({
        severity: 'error',
        summary: ORDER_CATEGORY.TOAST_SUMMARY_ERROR,
        detail: `Please create a request for the record subject ${unmappedSubjects.join(', ')}`,
        sticky: true,
      });
      this.trackPlaceOrder('place-order:validation:failed', {
        reason: 'unmapped-subjects',
        unmappedSubjectCount: unmappedSubjects.length
      });
      return false;
    }
    return true;
  }

  private addContactToContactBook(
    contactListId: string,
    contact: ContactItemCreation,
  ): void {
    this.newContactsForContactBook.push({
      contactListId,
      contact,
    });
  }

  private buildContactBookContact(
    displayName: string,
    title: string,
    barNumber: string,
    locators: PartyLocatorCreation[],
  ): ContactItemCreation {
    return {
      party: {
        displayName,
        typeCode: 'Person',
        typeCodeCustomerValue: '',
        interpreterNeeded: true,
        interpretedLanguage: '',
        names: [
          {
            function: 'first-name',
            text: this.contactHelperService.getFirstName(displayName),
          },
          {
            function: 'last-name',
            text: this.contactHelperService.getLastName(displayName),
          },
          {
            function: 'title',
            text: title,
          },
          {
            function: 'barNumber',
            text: barNumber,
          },
        ],
        locators,
      },
      tags: [
        {
          tagName: title,
        },
      ],
      active: true,
    };
  }

  private setGeneratedPartyKeys(
    party: CaseFilePartyItemCreation,
    keys: any,
  ): void {
    if (!party.party) {
      return;
    }

    party.party.keys = this.CreateUUIDService.generatePartyExternalId(keys);
  }

  // Adds a represents relationship between source and target party keys.
  private addRepresentsRelationship(
    sourceKeys: any[] | undefined,
    targetKeys: any[] | undefined,
  ): void {
    this.partyRelationships.push({
      sourcePartyKey: this.CreateUUIDService.getPartyExternalId(
        sourceKeys ?? [],
      ),
      targetPartyKey: this.CreateUUIDService.getPartyExternalId(
        targetKeys ?? [],
      ),
      relation: 'represents',
    });
  }

  // Adds a represents relationship using a known source external id.
  private addRepresentsRelationshipByExternalId(
    sourcePartyKey: any,
    targetKeys: any[] | undefined,
  ): void {
    this.partyRelationships.push({
      sourcePartyKey,
      targetPartyKey: this.CreateUUIDService.getPartyExternalId(
        targetKeys ?? [],
      ),
      relation: 'represents',
    });
  }

  // Returns existing named person party or creates one with provided role.
  private getOrCreateNamedPersonParty(
    parties: CaseFilePartyItemCreation[],
    displayName: string,
    roleCode: PartyRoleCode,
    keys: any,
  ): CaseFilePartyItemCreation {
    const existingParty = parties.find(
      (party) => party.party?.displayName === displayName,
    );
    if (existingParty) {
      return existingParty;
    }

    const party = this.getCasePartyByTypeCode(
      PartyTypeCode.Person,
      displayName,
    );
    party.roles = [];
    party?.roles?.push(this.partyFactoryService.getRole(roleCode, ''));
    this.setGeneratedPartyKeys(party, keys);
    parties.push(party);

    return party;
  }

  /**
   * Validates request number formats returned from the backend after order submission.
   * Supports both hierarchical format (001, 001-01, 001-02-03) and legacy format (1, 2, 3).
   * Logs parent-child relationships to console for debugging split requests.
   * Displays user warning toast if invalid formats are detected.
   * 
   * @param response - The order response from createOrder or updateOrder API calls
   */
 private validateRequestNumberFormat(response: any): void {
  if (!response?.retrievalObjective?.requests) return;

  const result = this.validatorService.validate(
    response.retrievalObjective.requests
  );

  console.log(
    `[Validation] Total: ${result.totalCount} | ` +
    `Hierarchical: ${result.hierarchicalCount} | ` +
    `Legacy: ${result.legacyCount} | ` +
    `Invalid: ${result.invalidCount}`
  );

  if (result.invalidCount > 0) {
    this.messageService.add({
      severity: 'warn',
      summary: 'Request Number Format Warning',
      detail: `${result.invalidCount} request(s) have unexpected format.`
    });
  }
}
}
